export const FETCH_ALL_CONTENT = 'fetch_all_content';
export const FETCH_ALL_CONTENT_SUCCESS = 'fetch_all_content_success';
export const EDIT_CONTENT = 'edit_content';
export const DELETE_CONTENT = 'delete_content';
export const CREATE_CONTENT = 'create_content';
export const CREATE_CONTENT_SUCCESS = 'create_content_success';
export const UPDATE_CONTENT_SUCCESS = 'update_content_success';
export const UPDATE_CONTENT = 'update_content';
export const DELETE_CONTENT_SUCCESS = 'delete_content_success';
export const SET_CONTENT = 'set_content';